import React, { useState } from 'react';
import Button from '../button/Button';
import Modal from '../modal/Modal';
import style from './UserInstructionsModal.module.scss';
import useLabels from '../../hooks/useLabels';
// import parse from 'html-react-parser';
// import Alert from '../alert/Alert';
// import Loader from '../loader/Loader';
// import useTerms from '../../hooks/useTerms';
import MainUserInstructions from '../../elements/chat-mainUserInstructions/MainUserInstructions';

type Props = {
    isModalOpen: boolean;
    closeModal: () => void;
};

const UserInstructionsModal: React.FC<Props> = ({ isModalOpen, closeModal }) => {
    const labels = useLabels();
    // const { terms, isLoading, error } = useTerms({ active: isModalOpen });
    const [isDisclaimerRead, setIsUserInstructionRead] = useState(false);
    const mainUserInstruction = <MainUserInstructions {...{}} onDisclaimerIsRead={setIsUserInstructionRead} />;

    return (<>
        <Modal
            className={style.modal}
            size='large'
            isOpen={isModalOpen}
            headline={labels.userInstructions}
            body={mainUserInstruction}
            footer={<Button label={labels.userInstructionButton} onClick={closeModal} />}
            closeOnBackdropClick
            closeOnEscape
            onClose={closeModal}
        />
    </>
    );
};

export default UserInstructionsModal;
